import React, { useEffect, useMemo, useState } from 'react';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useCommonContext } from '../../../../../contexts/CommonContext';
import { useI18nContext } from '../../../../../contexts/I18nContext';
import { Observer } from 'mobx-react-lite';
import MessageCard from '../../../../../ui_components/MessageCard/MessageCard';
import ReferenceItemSalePricesProperties from './ReferenceItemSalePricesProperties';
import ReferenceItemSalePriceStore from './ReferenceItemSalePriceStore';
import { useStyles } from './ReferenceItemSalePrices.style';
import ReferenceItemSalePriceRow from './ReferenceItemSalePricesRow/ReferenceItemSalePriceRow';
import FilterInput from '../../../../../shared_components/Inputs/FilterInput/FilterInput';
import CopyServicePricesButton from '../../../../../shared_components/Buttons/CopyServicePricesButton/CopyServicePricesButton';
import SalePriceItemType from '../../../../../entities/SalePriceItemType';
import ButtonSize from '../../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../../ui_components/Button/ButtonType';


const ReferenceItemSalePrices: React.FC<ReferenceItemSalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const store = useMemo(() => new ReferenceItemSalePriceStore(commonStore), [commonStore]);
    const classes = useStyles();

    const [inputValue, setInputValue] = useState("");
    const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

    useEffect(() => {
        store.getReferenceItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onValueChange = (value: string) => {
        const upperValue = value.toUpperCase();
        setInputValue(upperValue);

        if (debounceTimeout) clearTimeout(debounceTimeout);

        const timeout = setTimeout(() => {
            store.setFilter(upperValue);
        }, 800);

        setDebounceTimeout(timeout);
    };

    return (
        <Observer>
            {() => (
                <div className={classes.package_sale_prices_container}>
                    <div className={classes.tools_container}>
                        <FilterInput
                            value={inputValue}
                            placeholder={i18n.translate("INVENTORY_ITEMS_PLACEHOLDER")}
                            onChange={onValueChange}
                        />
                        <CopyServicePricesButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            sourceSalePriceId={salePrice?.id ?? ''}
                            serviceName={SalePriceItemType.PACKAGE_REFERENCE_ITEM}
                            type={ButtonType.SECONDARY}
                        />
                    </div>
                    {!store.isEmpty &&
                    <div className={classes.package_sale_prices_table}>
                        <div className={classes.elements_container}>
                            {store.referenceItems.map((referenceItem, i) => (
                                <ReferenceItemSalePriceRow
                                    onUpdate={onUpdate}
                                    referenceItem={referenceItem}
                                    salePrice={salePrice}
                                    key={i}
                                />
                            ))}
                        </div>
                    </div>}
                    {store.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default ReferenceItemSalePrices;
